<div class="container-head">
    <div>
        <button type="button" class="btn btn-outline-secondary me-2" (click)="downloadCSV()"><i
                class="bi bi-download"></i>
            {{'MIMESYS.DOWNLOAD_CSV' | translate }}</button>
    </div>
    <div>
        <button type="button" class="btn btn-outline-secondary me-2" (click)="downloadSummary()"><i
                class="bi bi-download"></i>
            {{'Download Summary' | translate }}</button>
    </div>
</div>
<div class="container-filters">
    <hbo-analytics-filters [typeData]="'fitsAnalytics'" (reload)="reload($event)"></hbo-analytics-filters>
</div>
<div class="container-table">
    <hbo-analytics-table *ngIf="entities$ | async as entities" [typeData]="'fitsAnalytics'" [columns]="columns"
        [items]="entities" (reload)="searchEntities($event)">
        <tbody class="table-group-divider">
            <ng-container *ngFor="let item of data$">
                <tr class="accordion-header">
                    <td>{{ item.id }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.code ? item.code : '-' }}</td>
                    <td>{{ item.team }}</td>
                    <td>{{ item.category ? item.category : '-' }}</td>
                    <td>{{ item.finished }}</td>
                    <td>{{ item.pending }}</td>
                    <td>{{ item.total}}</td>
                </tr>
            </ng-container>
            <tr *ngIf="!data$.length">
                <td colspan="7" class="text-center">{{ 'COMMON.NO_RESULTS' | translate }}</td>
            </tr>
        </tbody>
    </hbo-analytics-table>
</div>